import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {FeatureEventData, slotStore} from '@gongxigames/framework/slotV2/globals';

export class BuyFeaturePopUpUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('General.disableSpinButton');
        this.emitter.emit('UI.updateUIElementsState', 'BuyFeaturePopUpUIState');

        this.emitter.on('Game.command.round.featureStopped', (data: FeatureEventData) => {
            if (data.type === 'buyFeaturePopup') {
                slotStore.batchUpdate({
                    feature_type: null
                });
                this.emitter.emit('UI.buyFeature.bet.reSet');

                this.onExecuted?.();
            }
        });

        this.emitter.on('Game.command.round.featureStarted', (data: FeatureEventData) => {
            if (data.type === 'spin') {
                this.emitter.emit('UI.buyFeature.bet.started');

                slotStore.batchUpdate({
                    feature_type: data
                });
                this.onExecuted?.();
            }
        });
    }

    getName(): string {
        return 'BuyFeaturePopUpUIAct';
    }
}